// IMPORTANT: This must be imported FIRST to set __webpack_public_path__ before any chunks load
import '../publicpath';

import React from 'react';

import { createRoot } from 'react-dom/client';

import { App } from './App';

createRoot(document.getElementById('root')!).render(<App />);
